export function TicketProcessIcon({
    icon,
    size,
}: {
    icon: 'ticket' | 'exitStation' | 'barrier' | 'qrScan';
    size: 'small' | 'large';
}) {
    const viewBoxSize = size === 'small' ? 54 : 60;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        >
            <ProcessIcon icon={icon} />
        </svg>
    );
}

function ProcessIcon({
    icon,
}: {
    icon: 'ticket' | 'exitStation' | 'barrier' | 'qrScan';
}) {
    switch (icon) {
        case 'ticket':
            return <Ticket />;
        case 'exitStation':
            return <ExitStation />;
        case 'barrier':
            return <Barrier />;
        case 'qrScan':
            return <QrScan />;
    }
}

export function TicketIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 417 250`}
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinejoin: 'round',
                strokeMiterlimit: 2,
            }}
        >
            <g>
                <path
                    d="M-0,0.037l416.666,0l0,250l-416.666,0l-0,-250Zm208.809,152c9.445,0 17.114,7.669 17.114,17.114c-0,9.445 -7.669,17.114 -17.114,17.114c-9.445,-0 -17.114,-7.669 -17.114,-17.114c0,-9.445 7.669,-17.114 17.114,-17.114Zm-95.008,-38.229c9.446,0 17.114,7.669 17.114,17.114c0,9.445 -7.668,17.114 -17.114,17.114c-9.445,-0 -17.113,-7.669 -17.113,-17.114c-0,-9.445 7.668,-17.114 17.113,-17.114Zm-96.725,-41.944c6.656,0 12.059,5.403 12.059,12.059c0,6.655 -5.403,12.059 -12.059,12.059c-6.655,-0 -12.059,-5.404 -12.059,-12.059c0,-6.656 5.404,-12.059 12.059,-12.059Zm46.636,0c6.656,0 12.059,5.403 12.059,12.059c0,6.655 -5.403,12.059 -12.059,12.059c-6.655,-0 -12.058,-5.404 -12.058,-12.059c-0,-6.656 5.403,-12.059 12.058,-12.059Zm50.089,0c6.656,0 12.059,5.403 12.059,12.059c0,6.655 -5.403,12.059 -12.059,12.059c-6.655,-0 -12.058,-5.404 -12.058,-12.059c-0,-6.656 5.403,-12.059 12.058,-12.059Zm142.783,0c6.655,0 12.058,5.403 12.058,12.059c0,6.655 -5.403,12.059 -12.058,12.059c-6.656,-0 -12.059,-5.404 -12.059,-12.059c-0,-6.656 5.403,-12.059 12.059,-12.059Zm48.249,0c6.655,0 12.058,5.403 12.058,12.059c0,6.655 -5.403,12.059 -12.058,12.059c-6.656,-0 -12.059,-5.404 -12.059,-12.059c-0,-6.656 5.403,-12.059 12.059,-12.059Zm95.752,0c6.656,0 12.059,5.403 12.059,12.059c0,6.655 -5.403,12.059 -12.059,12.059c-6.655,-0 -12.058,-5.404 -12.058,-12.059c-0,-6.656 5.403,-12.059 12.058,-12.059Zm-239.476,0c6.656,0 12.059,5.403 12.059,12.059c0,6.655 -5.403,12.059 -12.059,12.059c-6.655,-0 -12.058,-5.404 -12.058,-12.059c-0,-6.656 5.403,-12.059 12.058,-12.059Zm47.7,0c6.655,0 12.059,5.403 12.059,12.059c-0,6.655 -5.404,12.059 -12.059,12.059c-6.655,-0 -12.059,-5.404 -12.059,-12.059c0,-6.656 5.404,-12.059 12.059,-12.059Zm143.701,0c6.655,0 12.059,5.403 12.059,12.059c-0,6.655 -5.404,12.059 -12.059,12.059c-6.656,-0 -12.059,-5.404 -12.059,-12.059c0,-6.656 5.403,-12.059 12.059,-12.059Zm-288.798,-50.52c8.029,0 14.546,6.518 14.546,14.546c0,8.029 -6.517,14.546 -14.546,14.546c-8.028,0 -14.546,-6.517 -14.546,-14.546c0,-8.028 6.518,-14.546 14.546,-14.546Zm50.089,-0.244c8.029,-0 14.547,6.518 14.547,14.546c-0,8.028 -6.518,14.546 -14.547,14.546c-8.028,-0 -14.546,-6.518 -14.546,-14.546c0,-8.028 6.518,-14.546 14.546,-14.546Zm95.008,-0c8.028,-0 14.546,6.518 14.546,14.546c0,8.028 -6.518,14.546 -14.546,14.546c-8.028,-0 -14.546,-6.518 -14.546,-14.546c-0,-8.028 6.518,-14.546 14.546,-14.546Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
}

function Ticket() {
    return (
        <g fill="none" fillRule="evenodd">
            <path
                d="M5.324 35.34a2.814 2.814 0 0 1 0-3.978L31.361 5.324a2.814 2.814 0 0 1 3.978 0M48.836 18.82a2.814 2.814 0 0 1 0 3.978L22.798 48.836a2.814 2.814 0 0 1-3.978 0"
                stroke="currentColor"
                strokeWidth="1.512"
                strokeLinecap="round"
            />
            <path
                d="m34.053 13.555 5.18.875a.618.618 0 0 1 .508.507l.875 5.18c.099.595-.624.968-1.05.54l-6.054-6.052c-.428-.427-.054-1.15.541-1.05"
                fill="currentColor"
            />
            <path
                d="m19.533 31.832 1.898 1.897c.562.563 1.123.858 1.686.887.56.028 1.089-.204 1.584-.699.508-.51.77-1.07.787-1.682.017-.61-.232-1.183-.747-1.717l-1.65-1.652a.42.42 0 0 0-.592 0l-2.966 2.966zM17.8 33.566l-3.364 3.364a.42.42 0 0 1-.593 0L12.311 35.4a.42.42 0 0 1 0-.593l9.796-9.798a.42.42 0 0 1 .593 0l3.726 3.726c.775.774 1.312 1.6 1.615 2.472.303.873.35 1.731.14 2.573-.21.841-.65 1.599-1.32 2.27-1.019 1.016-2.168 1.474-3.446 1.37-1.279-.105-2.53-.768-3.753-1.99L17.8 33.566zM27.821 14.029l12.708 12.708M25.692 16.158 38.4 28.866M23.563 18.287l12.708 12.708M35.395 5.413l.457 2.143c.08.372.37.663.743.743l1.533.328a.962.962 0 0 1 .742.741l.327 1.533c.08.372.37.663.743.743l1.533.327c.372.08.661.37.74.742l.33 1.533c.079.372.368.662.74.741l1.533.329c.372.08.663.369.743.74l.327 1.534c.08.372.37.663.742.742l2.144.458M5.432 35.376l2.143.457c.372.08.663.37.743.743l.328 1.533a.962.962 0 0 0 .741.742l1.533.327c.372.08.663.37.743.743l.327 1.533c.08.372.37.661.742.74l1.533.33c.372.079.662.368.741.74l.329 1.533c.08.372.369.663.74.743l1.534.327c.372.08.663.37.742.742l.458 2.144"
                stroke="currentColor"
                strokeWidth="1.512"
                strokeLinecap="round"
            />
        </g>
    );
}

function Barrier() {
    return (
        <g
            stroke="currentColor"
            strokeWidth="1.512"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
        >
            <path d="M18.537 20.793H11.24V40.98h7.296s0 0 0 0V20.793zM18.625 20.094l-.75-3.053c-.17-.688-.64-1.152-1.169-1.152h-3.541c-.53 0-1 .464-1.169 1.152l-.75 3.053M18.537 40.983H11.24l-.078.066a6.364 6.364 0 0 0-2.148 3.734.954.954 0 0 0 .936 1.119h9.994c.52 0 .94-.422.94-.94h0a4.303 4.303 0 0 0-1.535-3.296l-.813-.683zM18.587 20.806 44.176 9.07a.788.788 0 0 1 1.044.389l.978 2.133a.788.788 0 0 1-.387 1.044L22.74 23.215l-3.756 1.722M24.408 18.292l-1.706 4.594M32.507 14.437l-1.794 4.834M40.482 10.917l-1.696 4.57" />
        </g>
    );
}

function ExitStation() {
    return (
        <g fill="none" fillRule="evenodd">
            <path
                d="M19.19 49.596H34.94a2.69 2.69 0 0 0 2.69-2.69V7.188A2.689 2.689 0 0 0 34.94 4.5H19.189A2.689 2.689 0 0 0 16.5 7.188v39.718a2.69 2.69 0 0 0 2.69 2.69z"
                stroke="currentColor"
                strokeWidth="1.512"
                strokeLinecap="round"
            />
            <path fill="currentColor" d="M16.598 35.745h20.934" />
            <path
                stroke="currentColor"
                strokeWidth="1.512"
                d="M16.598 35.745h20.934"
            />
            <path
                d="M29.907 20.902h-5.683a.439.439 0 0 1-.439-.438v-1.92c0-.243.197-.438.439-.438h5.683c.241 0 .438.195.438.438v1.92a.439.439 0 0 1-.438.438"
                fill="currentColor"
            />
            <path
                d="M29.787 15.981h-5.443a.558.558 0 0 1-.558-.558v-3.421c0-.31.25-.558.558-.558h5.443c.308 0 .558.249.558.558v3.421c0 .31-.25.558-.558.558z"
                stroke="currentColor"
                strokeWidth="1.512"
                strokeLinecap="round"
            />
            <path
                d="M27.255 25.116h-.378a6.975 6.975 0 0 1-6.975-6.975v-3.798a6.974 6.974 0 0 1 6.975-6.973h.378a6.974 6.974 0 0 1 6.975 6.973v3.798a6.975 6.975 0 0 1-6.975 6.975z"
                stroke="currentColor"
                strokeWidth="1.512"
                strokeLinecap="round"
            />
        </g>
    );
}

export function QrScan() {
    return (
        <svg
            width="100%"
            height="100%"
            viewBox={`0 0 1024 1024`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: '1.5',
            }}
        >
            <g transform="matrix(0.694319,0,0,0.694319,156.509,156.509)">
                <path
                    d="M170.667,170.667L426.667,170.667L426.667,426.667L170.667,426.667L170.667,170.667M853.333,170.667L853.333,426.667L597.333,426.667L597.333,170.667L853.333,170.667M597.333,640L682.667,640L682.667,554.667L597.333,554.667L597.333,469.333L682.667,469.333L682.667,554.667L768,554.667L768,469.333L853.333,469.333L853.333,554.667L768,554.667L768,640L853.333,640L853.333,768L768,768L768,853.333L682.667,853.333L682.667,768L554.667,768L554.667,853.333L469.333,853.333L469.333,682.667L597.333,682.667L597.333,640M682.667,640L682.667,768L768,768L768,640L682.667,640M170.667,853.333L170.667,597.333L426.667,597.333L426.667,853.333L170.667,853.333M256,256L256,341.333L341.333,341.333L341.333,256L256,256M682.667,256L682.667,341.333L768,341.333L768,256L682.667,256M256,682.667L256,768L341.333,768L341.333,682.667L256,682.667M170.667,469.333L256,469.333L256,554.667L170.667,554.667L170.667,469.333M384,469.333L554.667,469.333L554.667,640L469.333,640L469.333,554.667L384,554.667L384,469.333M469.333,256L554.667,256L554.667,426.667L469.333,426.667L469.333,256"
                    style={{
                        fill: 'white',
                        fillRule: 'nonzero',
                    }}
                />
            </g>
            <g transform="matrix(3.43861,0,0,3.44117,-1431.56,-284.127)">
                <path
                    d="M701.04,163.346C701.04,125.842 670.57,95.394 633.038,95.394L497.034,95.394C459.503,95.394 429.032,125.842 429.032,163.346L429.032,299.451C429.032,336.954 459.503,367.403 497.034,367.403L633.038,367.403C670.57,367.403 701.04,336.954 701.04,299.451L701.04,163.346Z"
                    style={{
                        fill: 'none',
                        stroke: 'rgb(217,38,38)',
                        strokeWidth: '25px',
                    }}
                />
            </g>
        </svg>
    );
}

export function Car() {
    return (
        <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 25 25`}
            style={{ display: 'block' }}
        >
            <g
                id="icon-motorwagen-klein"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinejoin="round"
            >
                <path
                    d="M19.8044444,5.073125 C19.5933333,4.44625 19.0022222,4 18.3055556,4 L6.69444444,4 C5.99777778,4 5.41722222,4.44625 5.19555556,5.073125 L3,11.4375 L3,19.9375 C3,20.521875 3.475,21 4.05555556,21 L5.11111111,21 C5.69166667,21 6.16666667,20.521875 6.16666667,19.9375 L6.16666667,18.875 L18.8333333,18.875 L18.8333333,19.9375 C18.8333333,20.521875 19.3083333,21 19.8888889,21 L20.9444444,21 C21.525,21 22,20.521875 22,19.9375 L22,11.4375 L19.8044444,5.073125 Z M6.69444444,15.6875 C5.81833333,15.6875 5.11111111,14.975625 5.11111111,14.09375 C5.11111111,13.211875 5.81833333,12.5 6.69444444,12.5 C7.57055556,12.5 8.27777778,13.211875 8.27777778,14.09375 C8.27777778,14.975625 7.57055556,15.6875 6.69444444,15.6875 Z M18.3055556,15.6875 C17.4294444,15.6875 16.7222222,14.975625 16.7222222,14.09375 C16.7222222,13.211875 17.4294444,12.5 18.3055556,12.5 C19.1816667,12.5 19.8888889,13.211875 19.8888889,14.09375 C19.8888889,14.975625 19.1816667,15.6875 18.3055556,15.6875 Z M5.11111111,10.375 L6.69444444,5.59375 L18.3055556,5.59375 L19.8888889,10.375 L5.11111111,10.375 Z"
                    stroke="currentColor"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
}

export function Motorcycle() {
    return (
        <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 25 25`}
            style={{ display: 'block' }}
        >
            <g
                id="icon-motorrad-klein"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinejoin="round"
            >
                <path
                    d="M18.275,10 C18.2435,10 18.2225,10.01 18.191,10.01 L13.9805,6 L9.35,6 L9.35,8 L13.1195,8 L15.2195,10 L6.7145,10 C4.1105,10 2,12.02 2,14.5 C2,16.99 4.1105,19 6.725,19 C9.056,19 10.988,17.38 11.366,15.27 L13.592,14 C13.571,14.17 13.55,14.33 13.55,14.5 C13.55,16.99 15.6605,19 18.275,19 C20.8895,19 23,16.99 23,14.5 C23,12.01 20.8895,10 18.275,10 Z M9.182,15.26 C8.846,16.27 7.859,17 6.6935,17 C5.2445,17 4.0685,15.88 4.0685,14.5 C4.0685,13.12 5.2445,12 6.6935,12 C7.8695,12 8.846,12.74 9.182,13.75 L6.2,13.75 L6.2,15.25 L9.182,15.26 Z M18.2435,17 C16.7945,17 15.6185,15.88 15.6185,14.5 C15.6185,13.12 16.7945,12 18.2435,12 C19.6925,12 20.8685,13.12 20.8685,14.5 C20.8685,15.88 19.6925,17 18.2435,17 Z"
                    stroke="currentColor"
                    fillRule="nonzero"
                />
            </g>
        </svg>
    );
}

export function RadioActive({
    fillColor,
    hookColor,
}: {
    fillColor?: string;
    hookColor?: string;
}) {
    return (
        <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 50 50`}
            style={{ display: 'block' }}
        >
            <g
                id="icon-radio-button-active"
                stroke="none"
                strokeWidth="1"
                fill="none"
            >
                <g
                    id="tw_checkbox_checked.png"
                    transform="translate(13.000000, 13.000000)"
                >
                    <circle
                        id="Oval-22"
                        fill={fillColor ? fillColor : '#262626'}
                        cx="12.5"
                        cy="12.5"
                        r="12.5"
                    />
                    <polygon
                        id="Page-1"
                        fill={hookColor ? hookColor : '#FFFFFF'}
                        points="19.0612723 7 9.84990755 16.2113647 5.92881799 12.2896888 5 13.2185068 9.8604623 18.0789691 20.0000586 7.93937274"
                    />
                </g>
            </g>
        </svg>
    );
}

export function RadioInactive() {
    return (
        <svg
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox={`0 0 50 50`}
            style={{ display: 'block' }}
        >
            <g
                id="icon-radio-button-inactive"
                stroke="none"
                strokeWidth="1"
                fill="none"
            >
                <circle
                    id="Oval-22"
                    stroke="#C3C3C3"
                    cx="25.5"
                    cy="25.5"
                    r="12.5"
                />
            </g>
        </svg>
    );
}
